export const mockGapAnalysisData = {
  summary: {
    rank: 7,
    visibility: 12.8,
    sentiment: 50,
    position: 7.0,
    sov: 9.4,
    leaders: ['Robinhood', 'thinkorswim', 'TradingView'],
    remainingLeaders: 3,
    description: '您的品牌已在部分 AI 回答中出现，但仍有较大提升空间。',
  },
  models: [
    {
      id: 'chatgpt',
      name: 'ChatGPT',
      website: 'https://chatgpt.com',
    },
    {
      id: 'gemini',
      name: 'Gemini',
      website: 'https://gemini.google.com',
    },
    {
      id: 'deepseek',
      name: 'DeepSeek',
      website: 'https://www.deepseek.com',
    },
    {
      id: 'kimi',
      name: 'Kimi',
      website: 'https://kimi.moonshot.cn',
    },
    {
      id: 'doubao',
      name: 'Doubao',
      website: 'https://www.doubao.com',
    },
    {
      id: 'yuanbao',
      name: 'Yuanbao',
      website: 'https://yuanbao.tencent.com',
    },
    {
      id: 'tongyi',
      name: 'Tongyi',
      website: 'https://tongyi.aliyun.com',
    },
  ],
  brands: [
    {
      id: 'tradingbase',
      name: 'TradingBase',
      domain: 'tradingbase.ai',
      isOwn: true,
      scores: {
        chatgpt: 16,
        gemini: 20,
        deepseek: 33,
        kimi: 39,
        doubao: 23,
        yuanbao: 28,
        tongyi: 21,
      },
    },
    {
      id: 'robinhood',
      name: 'Robinhood',
      domain: 'robinhood.com',
      scores: {
        chatgpt: 84,
        gemini: 81,
        deepseek: 78,
        kimi: 72,
        doubao: 69,
        yuanbao: 66,
        tongyi: 62,
      },
    },
    {
      id: 'thinkorswim',
      name: 'thinkorswim',
      domain: 'thinkorswim.com',
      scores: {
        chatgpt: 79,
        gemini: 74,
        deepseek: 70,
        kimi: 68,
        doubao: 64,
        yuanbao: 61,
        tongyi: 58,
      },
    },
    {
      id: 'tradingview',
      name: 'TradingView',
      domain: 'tradingview.com',
      scores: {
        chatgpt: 76,
        gemini: 78,
        deepseek: 73,
        kimi: 71,
        doubao: 67,
        yuanbao: 63,
        tongyi: 60,
      },
    },
    {
      id: 'webull',
      name: 'Webull',
      domain: 'webull.com',
      scores: {
        chatgpt: 66,
        gemini: 61,
        deepseek: 59,
        kimi: 55,
        doubao: 52,
        yuanbao: 48,
        tongyi: 44,
      },
    },
    {
      id: 'fidelity',
      name: 'Fidelity',
      domain: 'fidelity.com',
      scores: {
        chatgpt: 62,
        gemini: 58,
        deepseek: 53,
        kimi: 50,
        doubao: 47,
        yuanbao: 45,
        tongyi: 42,
      },
    },
    {
      id: 'schwab',
      name: 'Charles Schwab',
      domain: 'schwab.com',
      scores: {
        chatgpt: 58,
        gemini: 56,
        deepseek: 49,
        kimi: 46,
        doubao: 41,
        yuanbao: 38,
        tongyi: 36,
      },
    },
  ],
};
